<template>
	<div class="d-flex h-100 home" style="gap: .5em">
		<b-card no-body header="Channels" class="d-flex flex-column overflow-hidden">
			<template #header>
				Channels
				<div class="float-right">
					<a class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/channelList.html`" @click.prevent="openPopup(`${$baseUrl}/app/channelList.html`, 400, 700)" title="Pop out channel list"><b-icon icon="box-arrow-up-right"></b-icon></a>
					<b-button v-if="!!restreamingData" v-b-toggle.collapse-video size="sm" class="card-header-btn" variant="primary">Preview <b-icon icon="arrows-expand"></b-icon></b-button>
				</div>
			</template>
			<b-collapse v-if="restreamingData" id="collapse-video" ref="collapseVideo" v-model="showRestreamingPreview">
				<b-aspect aspect="16:9" style="background: black; line-height: 0">
					<div v-if="showRestreamingPreview && restreamingData?.status?.status == 'live'" style="position: relative; height: 100%">
						<div style="position: absolute; left: 0; top:0; right: 0; line-height: 1em" class="p-1">
							<b-badge :variant="restreamingData.status.status == 'live' ? 'primary' : 'default'">{{restreamingData.status.status.toUpperCase()}}</b-badge>
							<b-badge variant="secondary" class="ml-1">{{restreamingData.status.uptime}}</b-badge>
						</div>
						<div v-if="videoLoading" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; line-height: 300px; text-align: center; vertical-align: middle">
							<b-icon icon="circle-fill" animation="throb"></b-icon>
						</div>
						<hls-player ref="player" :source="restreamingData.playbackUrlSecure||restreamingData.playbackUrl" @hlsManifestLoading="videoLoading=true" @hlsInitPtsFound="videoLoading=false" @muted="muted=true" @unmuted="muted=false" @pause="playing = false" @play="playing = true"></hls-player>
						<div style="position: absolute; bottom: 0; left: 0; right: 0; line-height: 1em" class="p-1">
							<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.togglePause()"><b-icon :icon="playing?'pause-fill':'play-fill'"/></button>
							<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.toggleMute()"><b-icon :icon="muted?'volume-up-fill':'volume-mute-fill'"/></button>
						</div>
					</div>
					<div v-else style="padding: 70px 50px 0">
						<br /><br />
						<b-input-group prepend="Restreaming service" label-for="restreaming-service-name" size="sm" class="mb-2">
							<b-form-input id="restreaming-service-name" size="sm" readonly :value="restreamingData.serviceName" />
						</b-input-group>
						<b-input-group prepend="SRT URL" label-for="srt-url" size="sm" class="mb-2">
							<b-form-input id="srt-url" placeholder="srt://" readonly :value="restreamingData.srtUrl" @focus="$event.target.select()"/>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.srtUrl, 'Copied SRT URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<b-input-group prepend="RTMP URL" label-for="rtmp-url" size="sm" class="mb-2">
							<b-form-input id="rtmp-url" placeholder="rtmp://" readonly :value="restreamingData.rtmpUrl" @focus="$event.target.select()"/>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpUrl, 'Copied RTMP URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<b-input-group prepend="Stream key" label-for="rtmp-key" size="sm" class="mb-2">
							<b-form-input id="rtmp-key" readonly :type="showRtmpKey?'text':'password'" :value="restreamingData.rtmpKey" @focus="$event.target.select()"/>
							<b-input-group-append><b-button variant="outline-info" @click="showRtmpKey=!showRtmpKey"><b-icon icon="eye"></b-icon></b-button></b-input-group-append>
							<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpKey, 'Copied stream key to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
						</b-input-group>
						<div class="text-right">
							<b-button variant="warning" size="sm" @click="$refs.streamResetModal.show()">Reset stream</b-button>
						</div>
					</div>
				</b-aspect>
			</b-collapse>
			<div class="p-3" v-if="!!restreamingData">
				<b-spinner v-if="loading>0" small label="Spinning" class="ml-3"></b-spinner>
				<span v-else>
					<span v-if="user.title_status == 'enabled'"><span v-if="user?.stream_title">{{user.stream_title}} </span><i v-else>Please set a title</i> <b-badge>{{user.stream_category_name}}</b-badge></span><i v-else>Automatic stream titles disabled</i>
					<a @click.prevent.stop="$refs.metadataModal.show()" href="#" class="ml-2"><b-icon style="font-size: 1em" icon="pencil-fill"></b-icon></a>
				</span>
			</div>
			<b-alert :show="!!error" variant="danger" class="m-2">{{error&&(error.error||error.toString())}}</b-alert>
			<div class="h-100 d-flex flex-column overflow-hidden">
				<div class="flex-fill overflow-auto">
					<channel-list @updated="$refs.chatLog?.bottomOut()" @edit="$refs.channelModal.showEdit($event.service_id, $event.token)" ref="channelList"></channel-list>
				</div>
				<div class="p-2">
					<b-button class="w-100" variant="primary" @click="$refs.channelModal.show()">Add channel</b-button>
				</div>
			</div>
			<channel-modal ref="channelModal" @saved="$refs.channelList.channelPoller.start(); $emit('updated')"></channel-modal>
			<stream-reset-modal ref="streamResetModal" @saved="reloadUserRestreamingData()" />
			<b-modal ref="metadataModal" title="Stream details" @show="loadMetadata" @ok.prevent="saveMetadata">
				<b-form-group>
					<b-form-checkbox switch inline class="mr-0" v-model="metadata.title_status" value="enabled" unchecked-value="disabled">Enable automatic titles and posts</b-form-checkbox>
				</b-form-group>
				<b-form-text class="mb-3" v-if="metadata.title_status == 'enabled'">Use tags such as {EPISODE} and {DATE} which get automatically updated</b-form-text>
				<b-form-group label="Title" v-if="metadata.title_status == 'enabled'">
					<b-input v-model="metadata.stream_title_template"></b-input>
					<div class="p-1 text-info">{{replaceTemplateTags(metadata.stream_title_template, metadata)}}</div>
				</b-form-group>
				<b-form-group label="Description" v-if="metadata.title_status == 'enabled'">
					<b-textarea v-model="metadata.stream_description_template"></b-textarea>
					<div class="p-1 text-info">{{replaceTemplateTags(metadata.stream_description_template, metadata)}}</div>
				</b-form-group>
				<b-form-group label="Category" v-if="metadata.title_status == 'enabled'">
					<b-select v-model="metadata.stream_category_id" :options="categories" value-field="id" text-field="name"></b-select>
				</b-form-group>
				<b-form-group label="Episode number" v-if="metadata.title_status == 'enabled'">
					<b-input type="number" min="1" v-model="metadata.stream_episode_number"></b-input>
				</b-form-group>
				<b-form-group label="Timezone" v-if="metadata.title_status == 'enabled'">
					<b-select v-model="metadata.timezone" :options="timezones"></b-select>
				</b-form-group>
				<b-alert :show="!!metadataError" variant="danger" class="m-2">{{metadataError&&(metadataError.metadataError||metadataError.toString())}}</b-alert>
				<template #modal-footer="{ cancel: cancel_fn, ok: ok_fn }">
					<div class="w-100">
						<div class="float-right">
							<b-spinner v-show="metadataLoading>0" small label="Spinning" class="mr-3"></b-spinner>
							<b-button variant="primary" type="submit" @click="ok_fn()" class="mr-2">
								Update
							</b-button>
							<b-button @click="cancel_fn()">
								Close
							</b-button>
						</div>
					</div>
				</template>
			</b-modal>
		</b-card>
		<b-card no-body class="d-flex flex-column overflow-hidden">
			<template #header>
				<b-dropdown class="current-log" variant="link" no-caret toggle-class="text-decoration-none text-body">
					<template #button-content>{{currentLog === 'alerts' ? 'Alerts' : 'Chat log'}} <b-icon icon="chevron-down"></b-icon></template>
					<b-dropdown-item @click="currentLog = 'chat'">Chat log</b-dropdown-item>
					<b-dropdown-item @click="currentLog = 'alerts'">Alerts</b-dropdown-item>
				</b-dropdown>
				<div class="float-right">
					<a v-if="currentLog === 'alerts'" class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/alerts.html`" @click.prevent="openPopup(`${$baseUrl}/app/alerts.html`, 400, 700)" title="Pop out alerts log"><b-icon icon="box-arrow-up-right"></b-icon></a>
					<a v-else class="btn btn-default btn-sm card-header-btn" target="_blank" :href="`${$baseUrl}/app/chat.html`" @click.prevent="openPopup(`${$baseUrl}/app/chat.html`, 400, 700)" title="Pop out chat log"><b-icon icon="box-arrow-up-right"></b-icon></a>
				</div>
			</template>
			<chat-log v-if="currentLog === 'chat'" class="flex-fill" :serviceIcons="serviceIcons" ref="chatLog"></chat-log>
			<alert-log v-else class="flex-fill" :serviceIcons="serviceIcons" ref="alertLog"></alert-log>
		</b-card>
	</div>
</template>

<script>
import ChatLog from '../components/ChatLog.vue';
import AlertLog from '../components/AlertLog.vue';
import ChannelList from '../components/ChannelList.vue';
import StreamResetModal from '../components/User/Modal/StreamReset.vue';
import HlsPlayer from '../components/HlsPlayer.vue';
import FetchPoller from '../FetchPoller';
import util from '../util';
import ChannelModal from '../components/Channel/Modal/ChannelModal';

export default {
	name: 'Home',
	data() { return {
		loading: 0,
		error: null,
		user: {},
		restreamingData: null,
		muted: true,
		playing: false,
		videoLoading: false,
		services: [],
		serviceIcons: {},
		showRestreamingPreview: true,
		showRtmpKey: false,
		chatSocket: null,
		metadata: {},
		metadataError: null,
		metadataLoading: 0,
		categories: [],
		timezones: ['UTC'],
		titleLoading: 0,
		currentLog: localStorage.getItem('currentLog') || 'chat',
	}},
	watch: {
		showRestreamingPreview(newValue) {
			localStorage.setItem('showRestreamingPreview', newValue ? 'true' : 'false');
		},
		currentLog(newValue) { localStorage.setItem('currentLog', newValue) }
	},
	components: {
		ChatLog,
		AlertLog,
		ChannelList,
		StreamResetModal,
		HlsPlayer,
		ChannelModal,
	},
	async mounted() {
		try {
			this.error = null;
			this.loading++;
			this.showRestreamingPreview = localStorage.getItem('showRestreamingPreview') == 'true' ? true : false;
			this.serviceIcons = {};
			const services = await this.$api.get('services');
			this.services = services.filter(s => s.capabilities.indexOf('chat') != -1);
			for(let service of services)
				if(service.icon && service.icon.url)
					this.serviceIcons[service.id] = service.icon.url;
			this.restreamingPoller = new FetchPoller(() => this.loadUserRestreamingData(), 5 * 60 * 1000);
			this.restreamingPoller.start();

			await this.loadUserData();

			this.subId = this.$socket.subscribe(this.user.widget_hash, {
				userChanged: () => this.loadUserData(),
				restreamStatus: status => {
					if(status.createdTime) {
						status.createdTime = new Date(status.createdTime);
						status.uptime = this.computeUptime(status.createdTime);
					}
					this.restreamingData.status = status;
				},
			});

			this.$api.get('timezones').then(timezones => this.timezones = timezones.sort()).catch(e => this.error = e);
			this.$api.get('categories').then(categories => this.categories = categories.results).catch(e => this.error = e);

			this.uptimeInterval = setInterval(() => {
				if(!(this?.restreamingData?.status?.createdTime instanceof Date)) return;
				this.restreamingData.status.uptime = this.computeUptime(this.restreamingData.status.createdTime);
			}, 1000);

			window.addEventListener('message', this.onMessage);
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	beforeDestroy() {
		window.removeEventListener('message', this.onMessage);
		this.restreamingPoller?.stop();
		if(this.uptimeInterval) clearInterval(this.uptimeInterval);
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		onMessage(event) {
			if(event.origin !== process.env.VUE_APP_PIPIPUPUBASE) return;
			if(event.data.type == 'openChannelEdit')
				this.$refs.channelModal.showEdit(event.data.serviceId, event.data.channelToken);
		},
		replaceTemplateTags(str, data) {
			return (str||'Live with LiveJoiner').replaceAll('{EPISODE}', data.stream_episode_number).replaceAll('{DATE}', new Date().toLocaleDateString('en-US', { timeZone: data.timezone||'UTC' }));
		},

		async loadUserData() {
			this.user = await this.$api.get('userData');
			this.user.stream_title = this.replaceTemplateTags(this.user.stream_title_template, this.user);
		},

		async reloadUserData() {
			try {
				this.error = null;
				this.loading++;
				await this.loadUserData();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		loadUserRestreamingData() {
			return this.$api.get('userRestreamingData').then(data => {
				if(data.status.createdTime) {
					data.status.createdTime = new Date(data.status.createdTime);
					data.status.uptime = this.computeUptime(data.status.createdTime);
				}
				this.restreamingData = data;
			}, () => {
				this.restreamingData = null;
			});
		},

		copyAndToast(string, message, dropdown) {
			let target;
			if(dropdown) {
				target = dropdown.target;
				while(target.nodeName != 'DIV')
					target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
		},

		computeUptime(date) {
			return util.secondsToTime(Math.round(((new Date()).getTime() - date.getTime()) / 1000.0));
		},

		openPopup(url, width, height) {
			window.open(url,'winname',`directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=${width},height=${height}`);
		},

		async loadMetadata() {
			try {
				this.metadataError = null;
				this.metadataLoading++;
				this.metadata = {};
				this.metadata = await this.$api.get('userData');
			} catch(e) {
				this.metadataError = e;
			} finally {
				this.metadataLoading--;
			}
		},

		async saveMetadata() {
			try {
				this.metadataError = null;
				this.metadataLoading++;
				await this.$api.post('userData', {
					stream_title_template: this.metadata.stream_title_template,
					stream_description_template: this.metadata.stream_description_template,
					stream_category_id: this.metadata.stream_category_id,
					stream_episode_number: this.metadata.stream_episode_number,
					title_status: this.metadata.title_status,
					timezone: this.metadata.timezone,
				});
				await this.loadUserData();
				this.$refs.metadataModal.hide();
			} catch(e) {
				console.error(e);
				this.metadataError = e;
			} finally {
				this.metadataLoading--;
			}
		},

	}
};
</script>

<style>
.home {
	flex-direction: column;
}
.home > .card {
	flex: 1;
}
@media (min-aspect-ratio: 4/3) {
	.home {
		flex-direction: row;
	}
}

.vc-chrome {
	box-shadow: none;
}

.vc-chrome-color-wrap {
	width: 36px;
	position: relative;
}

.vc-chrome-active-color {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  overflow: hidden;
  z-index: 1;
}

.vc-chrome-color-wrap .vc-checkerboard {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-size: auto;
}

.chatLogWrap {
	position: relative;
	min-height: 500px;
}

.card-header-btn {
	margin: -10px 10px -10px 0px;
}

.card-header-btn:last-child {
	margin-right: -10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.current-log {
	position: relative;
	display: inline-block;
	margin: -.75rem 0 -.75rem -1.25rem;
	vertical-align: middle;

	> button.btn.dropdown-toggle {
		padding: 0.7rem 1.25rem;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}
}
</style>
